import { FormGroup } from '@/components/FormGroup';

import Details from './Details';

const ProducerDataBlock = () => {
  return (
    <FormGroup collapsable={false} showValidationState={false} allowEdit={false}>
      <Details />
    </FormGroup>
  );
};

export default ProducerDataBlock;
